import { render, staticRenderFns } from "./MaterialsTagsPrint.vue?vue&type=template&id=74d44542&scoped=true&"
import script from "./MaterialsTagsPrint.vue?vue&type=script&lang=js&"
export * from "./MaterialsTagsPrint.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsTagsPrint.vue?vue&type=style&index=0&id=74d44542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d44542",
  null
  
)

export default component.exports